/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useCallback, useEffect, useRef, useMemo, MutableRefObject } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { get } from "../../logics/src/utils/helpers";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { UserContext } from "wrapper/UserWrapper/context";
import { AddressContext } from "wrapper/AddressWrapper/context/addressContext";
import { NewAddressContextProvider } from "./context/newAddressContext";
import { SavedAddressContext } from "wrapper/SavedAddressWrapper/context/savedAddressContext";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { CommonContextContext } from "wrapper/CommonWrapper/context";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { redirectToCheckoutPage } from "shared/helpers/utils/redirectToCheckoutPage";
import { getAddressParams, getChangedFields, handleBackRedirection, validateInputs } from "./dependencies/helpers";
import { getStringFromId } from "../../helpers/vernacular";
import { getGenericMessage } from "layouts/GenericMessageBar/common/dependencies/helpers";
import {
  trackAddNewAddressBackCliked,
  trackAutoDetectClick,
  trackNewAddressPageLoad,
  trackNewAddressShipToThisAddressClick,
  trackPincodeNonServiceable,
  trackShipToThisAddressClicksError,
  trackUseDefaultAddressToggleClick,
  trackAddAddressBottomSheetLoads,
  trackAddAddressBottomSheetClosed,
  trackImportCtaClicked,
  trackImportAddressClicked,
  trackAddressImported,
  trackAddressImportedSuccess,
  trackAddAddressBottomSheetClicked,
  trackAddressAutoDetectFailure
} from "./dependencies/tracking";
import { getPincodeValue } from "layouts/Payment/common/dependencies/dependencyhelpers";
import { setCookie } from "../../helpers/utils/cookie";
import { checkIsAddressIdDelCookiePresent } from "layouts/Payment/common/dependencies/dependencyhelpers";
import {
  AppCallback,
  doAttachWebCallback,
  doCallAppCallback,
  WebCallback,
} from "helpers/utils/webView";
import { logger } from "logging";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { getAttributeFromQueryString } from "wrapper/PaymentWrapper/dependencies/helper";
import { doRedirect } from "helpers/utils/redirection";
import { getPlatform } from "../../helpers/index";
import { ORIGIN_SOURCE } from "shared/constants/index";
import { initialErrorState } from "./constants";
import { DEVICE_TYPE, GENERIC_MESSAGE_PAGE, NYKAA_USER, PAGE_NAMES, TRACKING_EVENTS } from "shared/constants";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { COUNTRIES_META } from "constants/cart";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { ADDRESS_TYPE, FORM_FIELD } from "constants/address";
import { CLIENT_URLS } from "constants/urls";
import { CartRefreshType } from "store/payment/transformers/cart/cartRefreshTransformer";
import { ILoadingExtraParams } from "wrapper/PaymentWrapper/context/paymentContext";
import { importAddress, importAndSaveAddress, setAddressGuest } from "store/address/services";
import { getRequestParamsForServiceability, showAddressNotServiceAbleBottomSheet } from "wrapper/AddressWrapper/dependencies/helpers";
import { setCheckoutSuccessToFalseInDataLayer } from "layouts/Payment/common/dependencies/tracking";
import { doCheckPaymentFromAddressPageExpEnable } from "wrapper/ExperimentAndSwitchWrapper/helpers";
import { getQueryStrings } from "layouts/CheckoutPayment/helpers";

export const NewAddressWrapper = (props: any) => {
  const history = useHistory();
  const queryString = useLocation().search;
  const editId = getAttributeFromQueryString(queryString, "id");
  const error = getAttributeFromQueryString(queryString, "error");
  const hasImportError = error === "importError";
  const platform = getPlatform();
  const NYKAA_USER = "nykaa user";

  const { applicationData } = useContext(ApplicationContext);
  const {
    AutoDetectLocation,
    AutoDetectLocationBottomSheet,
    NewAddressDesignExp,
    ImportAddress,
    PaymentFormAddressPage,
    ConvenienceCharges,
  } = useContext(ExperimentAndSwitchContext);

  const isNewAddressDesignEnabled = NewAddressDesignExp.experimentEnabled;
  const isImportAddressEnabled = ImportAddress.experimentEnabled;
  const isConvenienceChargesExperimentEnabled: boolean = ConvenienceCharges?.experimentEnabled;
  const { userData } = useContext(UserContext);
  const {
    setCanRedirectToNewPaymentScren,
    setCartInfo,
    commonData: { isFirstLandingPageAfterCheckout },
    setIsFirstLandingPageAfterCheckout,
    orderAmount
  } = useContext(CommonContextContext);
  const addressContext = useContext(AddressContext);
  const errorModalContext = useContext(ErrorModalContext);
  const savedAddressContext = useContext(SavedAddressContext);
  const { isBeautyPlatform, isApp, deviceType } = applicationData;

  const setIsShow = get(savedAddressContext, "setIsShow");
  const isShow = get(savedAddressContext, "isShow");

  let userName = userData?.name;
  /**
   * This condition is added because for new user automatically the name is coming as "Nykaa User"
   * So, we are making it empty, so that user has to manually enter the name.
   */
  if(userName?.toLowerCase() === NYKAA_USER){
    userName = "";
  }
  const userEmail = userData?.email;
  const userMobile = userData.mobile;
  const userCustomerId = userData?.id;
  const isGuest = userData?.isGuest;
  const hideEmail = isApp || (isNewAddressDesignEnabled && !isGuest) ? true : userData.hideEmail; // In new address design hiding email field for logged in users 
  const addressType = get(addressContext, "addressType");
  const setAddressLoading = get(addressContext, "setAddressLoading");
  const cartInfo = get(addressContext, "cartInfo");
  const pincodeAddressContext = get(addressContext, "pincode");
  const editAddressFormData = get(addressContext, "addressToEdit");
  const getAddressServiceability = get(addressContext, "getAddressServiceability");
  const editAddress = get(addressContext, "editAddress");
  const addNewAddress = get(addressContext, "addNewAddress");
  const getGeoAddress = get(addressContext, "getGeoAddress");
  const setAddress = get(addressContext, "setAddress");
  const addresses = get(addressContext, "addresses");
  const setAddressToEdit = get(addressContext, "setAddressToEdit");
  const setAddressType = get(addressContext, "setAddressType");
  const setIsShipToAddressClick = get(addressContext, "setIsShipToAddressClick");
  const isPincodeBottomSheetVisible = get(addressContext, "isPincodeBottomSheetVisible");
  const setIsPincodeBottomSheetVisible = get(addressContext, "setIsPincodeBottomSheetVisible");
  const setIsPaymentBottomSheetVisisble = get(addressContext, "setIsPaymentBottomSheetVisisble");
  const totalAddressCount = get(addressContext, "totalAddressCount");
  const isShipToAddressClick = get(addressContext, "isShipToAddressClick");
  const openErrorModal = get(errorModalContext, "openErrorModal");
  const isAddressIdDelCookiePresent = checkIsAddressIdDelCookiePresent();
  const isAddressDtoNull = cartInfo?.shippingAddress ? false : true;
  const initialAddressFormState = {
    name: userName as string,
    phone: isNewAddressDesignEnabled ? userMobile : "",
    house: "",
    area: "",
    pinCode: isNewAddressDesignEnabled ? "" : (cartInfo?.pincode || ""),
    email: userEmail,
    city: "",
    state: "",
    countryToShip: COUNTRIES_META.IN.CODE,
    isdCode: COUNTRIES_META.IN.DIAL_CODE,
    isSetDefault: true,
    addressId: "",
    isDefaultOptionChecked: isNewAddressDesignEnabled ? false : true,
    customerAddressId: "",
    //for fashion
    regionCode: "",
    regionId: "",
    countryName: "",
  };

  const isInputChanged: MutableRefObject<boolean> = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingParams, setLoadingParams] = useState({} as ILoadingExtraParams); // it is for loading params.
  const [addressForm, setAddressForm] = useState(initialAddressFormState);
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const [nameInputIcon, setNameInputIcon] = useState(false);
  const [phoneInputIcon, setPhoneInputIcon] = useState(false);
  const [emailInputIcon, setEmailInputIcon] = useState(false);
  const [isModalShow, setIsModalShow] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [formError, setFormError] = useState(initialErrorState);
  const [showAutoDetectBottomSheet, setShowAutoDetectBottomSheet] = useState(false); // bottom sheet shows auto deteted address with Confirm and Edit button
  const [showNewDetectLocationBottomSheet, setShowNewDetectLocationBottomSheet] = useState(false); // bottom sheet with Detect location and Fill manually button
  const [autoDetectBottomSheetSubtitle, setAutoDetectBottomSheetSubtitle] = useState("");
  const [autoDetectAddressDetails, setAutoDetectAddressDetails] = useState({
    pincode: "",
    address: "",
  });
  const [isEditAutoDetect, setIsEditAutoDetect] = useState(false);
  const [isUserEditingPincode, setIsUserEditingPincode] = useState(false);
  const [fetchingGeoLocation, setIsUserFetchingGeoLocation] = useState(false);
  const [errorFetchingGeoLocation, setErrorFetchingGeoLocation] = useState('');
  const [showPermissionToast, setShowPermissionToast] = useState(false);
  const [showImportAddressBottomSheet, setShowImportAddressBottomSheet] = useState(false);
  const [importedAddresses, setImportedAddresses] = useState([]);
  const [isImportButtonDisabled, setIsImportButtonDisabled] = useState(false);
  const [showAddressImportedSuccessBottomSheet, setShowAddressImportedSuccessBottomSheet] = useState(false);
  const [importSuccessMessage, setImportSuccessMessage] = useState('');
  const [showImportFailureToast, setShowImportFailureToast] = useState(false);
  const [fetchedImportAddressData, setFetchedImportAddressData] = useState(true);
  const autoDetectAddressRef = useRef({} as any);
  const isPaymentFormAddressPageExpEnable = doCheckPaymentFromAddressPageExpEnable({
    experiment: PaymentFormAddressPage.experimentEnabled,
    orderAmount,
    addressCount: totalAddressCount,
    isGuest: userData.isGuest
  });
  const isImportPage = window.location.pathname?.includes("import");
  const pincodeValue = isNewAddressDesignEnabled ? "" : getPincodeValue();
  const searchLocation = useLocation();
  const queryResult = getQueryStrings(searchLocation.search);
  const srcPage = queryResult.get('src') || '';
  const srcPageIsImport = srcPage == PAGE_NAMES.IMPORT_PAGE;

  
  /**
   * It is for auto scroll to that error field at the time of submit the address.
   */
  const [scrollToErrorField, setScrollToErrorField] = useState(false);
  let importedAddressesLenght = 0;
  let selectedAddressLenght = 0;
  let successfullyImportedAddressLength = 0;


  /**
   * @description It is for loading screen
   * @param state boolean
   * @param extraParams 
   */
  const setLoading = (state: boolean, extraParams?: ILoadingExtraParams) => {
    setIsLoading(state);
    if(extraParams && Object.keys(extraParams)){
      setLoadingParams(extraParams);
    }
  }

  useEffect(() => {
    if (isShipToAddressClick) {
      window.history.replaceState(
        null,
        document?.title,
        `${CLIENT_URLS.PAYMENT_BASE_URL}?shipTothisAddressClicked=true`
      );
      window.location.reload();
    }
  }, [isShipToAddressClick]);

  const shipToThisAddress = (addressDetail: IAddressDetails) => {
    setCanRedirectToNewPaymentScren(true);
    setLoading(true);

    const interactionLocation =
      addressType === ADDRESS_TYPE.EDIT ? PAGE_NAMES.EDIT_ADDRESS_PAGE : PAGE_NAMES.ADD_NEW_ADDRESS;
    const isAddressDefault = addressForm.isDefaultOptionChecked;
    const { city, state, countryToShip } = addressDetail;
    /** logging city,pincode, state & countryToShip just before calling addaddress api */
    if (!city || !state || !countryToShip) {
      logger.error(new Error("city, state, countryToShip is missing while calling add address"), {
        ny_city: city,
        ny_state: state,
        ny_country: countryToShip,
        postcode: addressForm.pinCode,
      });
      return;
    }

    allTrackingHandlerForApps({
      event: TRACKING_EVENTS.SHIP_TO_ADDRESS_CLICKS,
      isDefaultAddress: isAddressDefault,
      interactionLocation,
      isApp,
    });

    const params = getAddressParams({
      addressDetails: { ...addressForm, ...addressDetail, isAddressDefault },
      isGuest,
      deviceType,
    });

    if (addressType === ADDRESS_TYPE.EDIT) {
      editAddress(params)
        .then((response: { success: boolean; message: string; customerAddressId: string }) => {
          const message = get(response, "message");
          if (get(response, "success")) {
            const customerAddressId = response?.customerAddressId;
            const setAddressParams = {
              deviceType,
              domain: platform,
              addressId: customerAddressId,
              originSource: ORIGIN_SOURCE.ADDRESS,
            };
             
            setAddress(setAddressParams)
              .then((setAddressResponse: CartRefreshType) => {
                setCartInfo(setAddressResponse);
                if (deviceType === DEVICE_TYPE.MOBILE) {
                  setCookie("addressIdDel", customerAddressId, 365);
                  setCookie("pinCodeDel", addressForm.pinCode, 365);
                  /**
                   * if the pincode from the shippingAddressDTO is same as the pincode entered by the user in the input field
                   * then passing isAddressIdSame as true in redirectToCheckoutPage
                   */
                  redirectToCheckoutPage(
                    history,
                    (pincodeAddressContext === addressForm.pinCode) as boolean,
                    isAddressDtoNull,
                    ADDRESS_TYPE.EDIT,
                    addresses?.length,
                    setIsShipToAddressClick,
                    srcPageIsImport
                  );
                } else {
                  doRedirect({
                    url: CLIENT_URLS.PAYMENT_BASE_URL,
                    history,
                    isClientRedirection: true,
                    historyState: {},
                  });
                }
              })
              .catch((error: IError) => {
                trackShipToThisAddressClicksError({
                  errorType: error.message,
                  interactionLocation: PAGE_NAMES.ADD_NEW_ADDRESS
                });
                if(showAddressNotServiceAbleBottomSheet(error?.code)){
                  trackPincodeNonServiceable({pincode: addressForm.pinCode});
                  setIsPincodeBottomSheetVisible(true);
                  return;
                }
                openErrorModal(PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG, "");
              })
              .finally(() => {
                setLoading(false);
              });
          } else {
            openErrorModal(PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG, message);
            setLoading(false);
          }
        })
        .catch(() => {
          trackShipToThisAddressClicksError({
            errorType: 'Error in Edit Address API',
            interactionLocation: PAGE_NAMES.EDIT_ADDRESS_PAGE
          });
          setLoading(false);
        });
    } else if (isGuest) {
      setAddressGuest(params as IAddressParamsGuest, isConvenienceChargesExperimentEnabled)
        .then(setAddressResponse => {
          setCartInfo(setAddressResponse);
          if (deviceType === DEVICE_TYPE.MOBILE) {
            setCookie("addressIdDel", addressForm.addressId, 365);
            setCookie("pinCodeDel", addressForm.pinCode, 365);

            /**
             *if the pincode from the shippingAddressDTO is same as the pincode entered by the user in the input field
             *then passing isAddressIdSame as true in redirectToCheckoutPage
             */

            redirectToCheckoutPage(
              history,
              (pincodeAddressContext === addressForm.pinCode) as boolean,
              isAddressDtoNull,
              addressType,
              addresses.length,
              setIsShipToAddressClick,
              srcPageIsImport
            );
          } else {
            doRedirect({
              url: CLIENT_URLS.PAYMENT_BASE_URL,
              history,
              isClientRedirection: true,
              historyState: {},
            });
          }
        })
        .catch((error: IError) => {
          trackShipToThisAddressClicksError({
            errorType: 'Error in Set Address Guest API',
            interactionLocation: PAGE_NAMES.ADD_NEW_ADDRESS
          });
          if(showAddressNotServiceAbleBottomSheet(error?.code)){
            trackPincodeNonServiceable({pincode: addressForm.pinCode});
            setIsPincodeBottomSheetVisible(true);
            return;
          }
          openErrorModal(PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG, "");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      addNewAddress(params)
        .then((response: { customer_address_id: string; message: string }) => {
          const customerAddressId = response?.customer_address_id;
          const message = response?.message;

          if (customerAddressId) {
            const setAddressParams = {
              deviceType,
              domain: platform,
              addressId: customerAddressId,
              originSource: ORIGIN_SOURCE.ADDRESS,
            };

            setAddress(setAddressParams)
              .then((setAddressResponse: CartRefreshType) => {
                setCartInfo(setAddressResponse);
                if (deviceType === DEVICE_TYPE.MOBILE) {
                  setCookie("addressIdDel", customerAddressId, 365);
                  setCookie("pinCodeDel", addressForm.pinCode, 365);
                  
                  /**
                   * if payment form address page exp enable then do not redirect.
                   * if user refresh the page in that case order amount will be zero;
                   */
                  if(isPaymentFormAddressPageExpEnable){
                    setIsPaymentBottomSheetVisisble(true);
                    return; 
                  }
                  
                  /* if the pincode from the shippingAddressDTO is same as the pincode entered by the user in the input field
                  then passing isAddressIdSame as true in redirectToCheckoutPage
                  */
                  redirectToCheckoutPage(
                    history,
                    (pincodeAddressContext === addressForm.pinCode) as boolean,
                    isAddressDtoNull,
                    ADDRESS_TYPE.ADD,
                    addresses.length,
                    setIsShipToAddressClick,
                    srcPageIsImport
                  );
                } else {
                  doRedirect({
                    url: CLIENT_URLS.PAYMENT_BASE_URL,
                    history,
                    isClientRedirection: true,
                    historyState: {},
                  });
                }
              })
              .catch((error: IError) => {
                trackShipToThisAddressClicksError({
                  errorType: error.message,
                  interactionLocation: PAGE_NAMES.ADD_NEW_ADDRESS
                });
                if(showAddressNotServiceAbleBottomSheet(error?.code)){
                  trackPincodeNonServiceable({pincode: addressForm.pinCode});
                  setIsPincodeBottomSheetVisible(true);
                  return;
                }
                openErrorModal(PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG, "");
              })
              .finally(() => {
                setLoading(false);
              });
          } else {
            setLoading(false);
            trackShipToThisAddressClicksError({
              errorType: 'customer_address_id not found in Add Address API',
              interactionLocation: PAGE_NAMES.ADD_NEW_ADDRESS
            });
            openErrorModal(PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG, message);
          }
        })
        .catch(() => {
          trackShipToThisAddressClicksError({
            errorType: 'Error in Add New Address API',
            interactionLocation: PAGE_NAMES.ADD_NEW_ADDRESS
          });
          setLoading(false);
        });
    }
  }

  /**
   * Apps call it after the getAutoDetectAddress.
   * we get the address information such as pincode and address.
   */
  const setAutoDetectAddress = (info: IsetAutoDetectAddress) => {
    setLoading(false);
    if (info) {
      const autoDetectSubTitle = info?.address + ", " + info?.pincode;
      setAutoDetectAddressDetails(info);
      setShowAutoDetectBottomSheet(true);
      setAutoDetectBottomSheetSubtitle(autoDetectSubTitle);
    }
  };

  /**
   * it is for called when apps getting the error.
   */
  const autoDetectErrorHandler = (e: { errorMsg: string }) => {
    setLoading(false);
    const errMessage = new Error(`callbackName:${WebCallback.SET_AUTO_DETECT_ADDRESS}-${e.errorMsg}`);
    logger.error(errMessage);
  };

  /**
   * it is for auto detect tracking and called by apps incase for webview.
   */
  const setAutoDetectPermissionTracking = (info: { permissionGranted: boolean }) => {
    if (!info?.permissionGranted) {
      setLoading(false);
    }
    // apps tracking for checking user has allowed location permission or not

    allTrackingHandlerForApps({
      event: TRACKING_EVENTS.ADDRESS_AUTO_DETECT_INTERACTION,
      auto_detect_permission: info?.permissionGranted ? "allow" : "deny",
      isApp,
    });
  };

  /**
   * For get the current geo location incase of webview.
   */
  const getAppCurrentGeoLocation = () => {
    setLoading(true, {
      fallbackMessage: "Fetching your location",
    });

    doAttachWebCallback({
      callbackName: WebCallback.SET_AUTO_DETECT_ADDRESS,
      callbackDeclaration: setAutoDetectAddress,
    });
    doAttachWebCallback({
      callbackName: WebCallback.AUTO_DETECT_ERROR_HANDLER,
      callbackDeclaration: autoDetectErrorHandler,
    });
    doAttachWebCallback({
      callbackName: WebCallback.AUTO_DETECT_TRACKING,
      callbackDeclaration: setAutoDetectPermissionTracking,
    });

    doCallAppCallback({
      name: AppCallback.GET_AUTO_DETECT_ADDRESS,
      data: {
        callback: WebCallback.SET_AUTO_DETECT_ADDRESS,
        errorCallback: WebCallback.AUTO_DETECT_ERROR_HANDLER,
        trackingCallback: WebCallback.AUTO_DETECT_TRACKING,
      },
    });
  };

  const handleCloseAutoDetectBottomSheet = (isEdit: boolean) => {
    setShowAutoDetectBottomSheet(false);
  };

  const handleCloseNewAutoDetectBottomSheet = () => {
    trackAddAddressBottomSheetClosed();
    setShowNewDetectLocationBottomSheet(false);
  };

  const handleAddManuallyFromNewAutoDetectBottomSheet = () => {
    trackAddAddressBottomSheetClicked({
      interaction_location: 'addManually'
    });
    setShowNewDetectLocationBottomSheet(false);
    setTimeout(() => {
      autoDetectAddressRef.current.pinCode?.querySelector("#pinCode")?.focus();
      clearFormError('pinCode');
    }, 0);
  };

  const handleAddAddressManuallyClick = () => {
    setShowNewDetectLocationBottomSheet(false);
    setTimeout(() => {
      autoDetectAddressRef.current.pinCode?.querySelector("#pinCode")?.focus();
      clearFormError('pinCode');
    }, 0);
  };

  const handleNewAutoDetectBottomSheetClick = () => {
    trackAddAddressBottomSheetClicked({
      interaction_location: 'detectLocation'
    });
    setShowNewDetectLocationBottomSheet(false);
    getCurrentGeoLocation();
  };

  const handleCloseImportBottomSheet = () => {
    trackAddAddressBottomSheetClosed();
    setShowImportAddressBottomSheet(false);
  };

  const handleAddManuallyFromImportBottomSheet = () => {
    trackAddAddressBottomSheetClicked({
      interaction_location: 'addManually'
    });
    setShowImportAddressBottomSheet(false);
  };

  const handleImportAddressClick = () => {
    trackImportCtaClicked({
      interaction_location: PAGE_NAMES.CHECKOUT_FLOW_ADDRESS
  });
    setShowImportAddressBottomSheet(false);
    history.replace(CLIENT_URLS.IMPORT_ADDRESS);
  };

  const handleSuccessAutoDetectBottomSheet = (isEdit: boolean) => {
    if (autoDetectAddressDetails) {
      const currentAddress = Object.assign({}, addressForm);
      currentAddress.pinCode = autoDetectAddressDetails?.pincode;
      currentAddress.area = autoDetectAddressDetails?.address;
      isInputChanged.current = true;
      setShowAutoDetectBottomSheet(false);
      setAddressForm(currentAddress);
      setIsEditAutoDetect(isEdit);

      autoDetectAddressRef.current.pinCode?.getElementsByClassName("input-element")[0]?.focus();
    }
    // tracking for apps on address auto detect click
    if (isEdit) {
      // app tracking for Edit button click on auto detected address bottom sheet
      allTrackingHandlerForApps({ event: TRACKING_EVENTS.ADDRESS_AUTO_DETECT_EDIT, isApp });
    } else {
      // app tracking for Confirm button click on auto detected address bottom sheet
      allTrackingHandlerForApps({ event: TRACKING_EVENTS.ADDRESS_AUTO_DEECT_CONFIRM, isApp });
    }
  };


  const checkGeolocationPermission = async () => {
    if (navigator.permissions) {
      try {
        const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
  
        // Show toast if permission is denied
        if (permissionStatus.state === 'denied') {
          trackAddressAutoDetectFailure({
            error: 'Location permission denied'
          });
          setShowPermissionToast(true);
          const toastTimeout = setTimeout(() => {
            setShowPermissionToast(false);
          }, 5000);
  
          // Clear the timeout if necessary
          return () => clearTimeout(toastTimeout);
        }
  
        // If permission is granted or prompt is shown, proceed with geolocation
        if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
          getUserLocation();
        }
  
        // Listen for permission changes (if permission changes after the first check)
        permissionStatus.onchange = function () {
          if (permissionStatus.state === 'denied') {
            trackAddressAutoDetectFailure({
              error: 'Location permission denied'
            });
            setShowPermissionToast(true);
            const toastTimeout = setTimeout(() => {
              setShowPermissionToast(false);
            }, 5000);
            return () => clearTimeout(toastTimeout);
          } else if (permissionStatus.state === 'granted') {
            getUserLocation();
          }
        };
  
      } catch (error) {
        trackAddressAutoDetectFailure({
          error: 'Location permission denied'
        });
        logger.error("Error checking geolocation permission status: ", error);
      }
    } else {
      trackAddressAutoDetectFailure({
        error: 'Location permission API not supported'
      });
      logger.error("Permissions API is not supported by browser.");
      getUserLocation(); // Fallback to directly calling geolocation for older browsers
    }
  }

  const getUserLocation = () => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const params = {
            lattitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          setIsUserFetchingGeoLocation(true);
  
          getGeoAddress(params)
            .then((response: {
                area: string; 
                house: string; 
                city: string; 
                state: string; 
                country: string; 
                pinCode: string 
              }) => {
              if (response) {
                const currentAddress = { ...addressForm };
                currentAddress.pinCode = response.pinCode;
                currentAddress.area = response.area;
                currentAddress.house = response.house;
                currentAddress.city = response.city;
                currentAddress.state = response.state;
                currentAddress.countryToShip = response.country;
  
                trackAutoDetectClick({ pincode: response.pinCode });
                clearFormError('pinCode');
                isInputChanged.current = true;
                setAddressForm(currentAddress);
                setIsUserFetchingGeoLocation(false);
                if(!currentAddress.house && currentAddress.pinCode) {
                  // Case: when google api detects pincode but not house number, the focus/keypad should open for house number
                  setTimeout(() => {
                    autoDetectAddressRef.current.houseNo?.querySelector("#addressLine1")?.focus();
                  }, 0)
                }
              }
            })
            .catch(() => {
              trackAddressAutoDetectFailure({
                error: 'API error fetching location'
              });
              setIsUserFetchingGeoLocation(false);
              setErrorFetchingGeoLocation('Unable to detect location');
            });
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            trackAddressAutoDetectFailure({
              error: 'Location permission denied'
            });
            setShowPermissionToast(true);
            const toastTimeout = setTimeout(() => {
              setShowPermissionToast(false);
            }, 5000);
            return () => clearTimeout(toastTimeout);
          } else {
            trackAddressAutoDetectFailure({
              error: 'API error fetching location'
            });
            setErrorFetchingGeoLocation('Error fetching location');
          }
          setIsUserFetchingGeoLocation(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000, // 10 seconds
          maximumAge: 0,  // No caching, always fetch new location
        }
      );
    } else {
      trackAddressAutoDetectFailure({
        error: 'Location permission API not supported'
      });
      setErrorFetchingGeoLocation('Geolocation is not supported by browser.');
      logger.error("Geolocation is not supported by browser.");
    }
  }  

  const getCurrentGeoLocation = () => {
    if (isApp) {
      getAppCurrentGeoLocation();
      // tracking added for apps
      allTrackingHandlerForApps({
        event: TRACKING_EVENTS.ADDRESS_AUTO_DETECT_CLICK,
        interactionLocation:
          addressType == ADDRESS_TYPE.EDIT
            ? PAGE_NAMES.EDIT_ADDRESS_PAGE
            : PAGE_NAMES.ADD_NEW_ADDRESS,
        isApp,
      });
    } else {
      clearFormError('pinCode');
      setErrorFetchingGeoLocation('');
      checkGeolocationPermission();
    }
  };

  const handleDefaultAddressToggle = () => {
    let currentAddress = Object.assign({}, addressForm);
    currentAddress.isDefaultOptionChecked = !currentAddress.isDefaultOptionChecked;
    let toggledActionMessage = "unselectToggle";
    if (currentAddress.isDefaultOptionChecked) {
      toggledActionMessage = "selectToggle";
    }
    trackUseDefaultAddressToggleClick({
      selectedToggleValue: toggledActionMessage,
    });
    setAddressForm(currentAddress);
    setToggle(true);
  };

  const handleBackButton = () => {
    trackAddNewAddressBackCliked({
      isPincodeFilled: !!(addressForm.pinCode), 
      isHouseDetailsFilled: !!(addressForm.house), 
      isAreaDetailsFilled: !!(addressForm.area), 
      isInputChanged: isInputChanged.current,
      interactionLocation:
        addressType == ADDRESS_TYPE.EDIT
          ? PAGE_NAMES.EDIT_ADDRESS_PAGE
          : PAGE_NAMES.ADD_NEW_ADDRESS,
    });
    if (deviceType === DEVICE_TYPE.MOBILE) {
      if (isInputChanged.current) {
        setIsBottomSheetVisible(true);
      } else {
        handleBackRedirection({
          isGuest,
          shippingAddress: cartInfo?.shippingAddress,
          addressLength: addresses?.length || 0,
          isApp,
        });
      }
    } else if (deviceType === DEVICE_TYPE.DESKTOP) {
      if (isInputChanged.current || toggle) {
        setIsModalShow(true);
        setToggle(false);
      } else {
        
        setIsShow(false);
        setFormError(initialErrorState);
        setAddressType(ADDRESS_TYPE.ADD);
        history.replace(CLIENT_URLS.ADDRESS_BASE_URL);

      }
    }
  };

  const secondaryButtonAction = () => {
    setIsModalShow(false);
    setIsShow(false);
    isInputChanged.current = false;
    setAddressForm(initialAddressFormState);
    setFormError(initialErrorState);
  };

  const handleDontSaveClick = (sendTwoStepBack = false) => {
    setIsBottomSheetVisible(false);
    handleBackRedirection({
      isGuest,
      shippingAddress: cartInfo?.shippingAddress,
      addressLength: addresses?.length || 0,
      isApp,
      sendTwoStepBack
    });
  };

  const handleCloseBottomModal = () => {
    setIsBottomSheetVisible(false);
  };

  const onPincodeBottomSheetClose = () => {
    setIsPincodeBottomSheetVisible(false);
  };

  const nameInputIconVisible = () => {
    setNameInputIcon(true);
  };

  const phoneInputIconVisible = () => {
    setPhoneInputIcon(true);
  };

  const emailInputIconVisible = () => {
    setEmailInputIcon(true);
  };

  const clearInputField = () => {
    setNameInputIcon(true);
    setAddressForm({ ...addressForm, name: "" });
  };

  const clearPhoneInputField = () => {
    setPhoneInputIcon(true);
    setAddressForm({ ...addressForm, phone: "" });
  };

  const clearEmailInputField = () => {
    setEmailInputIcon(true);
    setAddressForm({ ...addressForm, email: "" });
  };

  const getPinCodeDetails = (isInternational?: boolean, isFormSubmit = false) => {
    const requestParams = getRequestParamsForServiceability({
      pincode: addressForm.pinCode,
      isInternational,
      countryToShip: addressForm.countryToShip,
      deviceType,
      isBeautyPlatform,
    });
    /**
     * When a user is editing pincode, we do not have to show N loader as per new experiment.
     * In New experimemt we show shimmer on Detected city widget instead of N loader.
     */
    if (!isNewAddressDesignEnabled || isFormSubmit) {
      setLoading(true); 
    } 
    getAddressServiceability(requestParams).then(
      (response: IServiceabilityRequest) => {
        if (response?.success) {
          const currentAddress = Object.assign({}, addressForm);
          currentAddress.city = response.city;
          currentAddress.state = response.state;
          currentAddress.countryToShip = response.country;
          if (!isBeautyPlatform) {
            currentAddress.regionCode = response.regionCode;
            currentAddress.regionId = response.regionId;
            currentAddress.countryName = response.countryName;
          }
          setAddressForm(currentAddress);
          if (isEditAutoDetect) {
            setTimeout(() => {
              autoDetectAddressRef.current.area?.querySelector(".input-area")?.focus();
            }, 0)
          } else if(!currentAddress.house){ // focus in input field when it is empty
            setTimeout(() => {
              if (!isNewAddressDesignEnabled || !isFormSubmit) {
                autoDetectAddressRef.current.houseNo?.querySelector("#addressLine1")?.focus();
              } 
            }, 0)
          }
          if (isFormSubmit) {
            shipToThisAddress(currentAddress);
          }
        } else {
          const currFormError = Object.assign({}, formError);
          currFormError.pinCode.hasError = true;
          /** pincodeBottomSheetTitle is added for edd api because we donot get any error message in that, so using default serviceable msg for it  */
          currFormError.pinCode.error = response.message || pincodeBottomSheetTitle;
          setFormError(currFormError);
          if (deviceType === DEVICE_TYPE.MOBILE) {
            trackPincodeNonServiceable({pincode: addressForm.pinCode});
            setIsPincodeBottomSheetVisible(true);
          }
          setLoading(false);
        }
        
      }
    ).catch(()=>{
      setLoading(false);
    })
    .finally(()=>{
      if(!isFormSubmit){
        setLoading(false);
      }
    });
  };

  const validateZipCode = useCallback(() => {
    let isEditing = addressType == ADDRESS_TYPE.EDIT;
    const errors = validateInputs({
      addressForm,
      formError,
      fieldName: FORM_FIELD.PINCODE,
      isEditing,
      isGuest,
    });
    if (addressForm.pinCode && !errors.pinCode.hasError) {
      if (addressForm.countryToShip == COUNTRIES_META.IN.CODE) {
        getPinCodeDetails(false);
      } else {
        getPinCodeDetails(true);
      }
    }

    setFormError(errors);
  }, [addressForm, getAddressServiceability]); // only [addressForm, getAddressServiceability] should be used

  const validateFormInput = useCallback(
    (key: string) => {
      let isEditing = addressType == ADDRESS_TYPE.EDIT;
      const errors = validateInputs({ addressForm, formError, fieldName: key, isEditing, isGuest });
      setFormError(errors);
      setNameInputIcon(false);
      setPhoneInputIcon(false);
      setEmailInputIcon(false);
    },
    [addressForm]
  ); // only [addressForm] should be used

  const clearFormError = (fieldName: string) => {
    setFormError({
      ...formError,
      [fieldName]: {
        hasError: false,
        error: "",
      },
    });
  };

  const handleInputChange = (value: string | null, key: string) => {
    isInputChanged.current = true;
    setScrollToErrorField(false);
    let currentAddress: any = Object.assign({}, addressForm);
    if (value || value == "") {
      switch (key) {
        case FORM_FIELD.PINCODE:
          value = value.replace(/[^0-9 ]/g, "");
          setErrorFetchingGeoLocation('');
          if (value.length > 6) {
            value = null;
          }
          if (value?.length === 6) {
            setTimeout(() => {
              autoDetectAddressRef.current.pinCode?.querySelector("#pinCode")?.blur();
            }, 0)
          }
          break;
        case FORM_FIELD.PHONE:
          value = value.replace(/[^0-9 ]/g, "");
          if (value.length > 10) {
            value = null;
          }
          break;
        default:
          break;
      }

      if (value != null) {
        currentAddress[key] = value;
        clearFormError(key);
      }

      setAddressForm(currentAddress);
    }
  };

  const handleFormSubmit = () => {
    setLoading(true);
    setScrollToErrorField(true);
    let isEditing = addressType == ADDRESS_TYPE.EDIT;
    const errors = validateInputs({ addressForm, formError, fieldName: "all", isEditing, isGuest });
    let isError = false;

    const keyMap: Record<string, string> = {
      house: "houseNo", // Map 'house' to 'houseNo'
    };
    
    Object.keys(errors).forEach(key => {
      // Resolve the correct key using the mapping
      const resolvedKey = keyMap[key] || key;
      if (errors[key as keyof FormErrorType]?.hasError) {
        if (isNewAddressDesignEnabled) {
          // CASE: If any field on address page have any error, bring it in focus and open keypad
          const inputWithError = autoDetectAddressRef.current?.[resolvedKey]?.getElementsByClassName("input-element")[0];
          if (inputWithError) {
            setTimeout(() => {
              inputWithError?.focus();
            }, 0);
          }
        }
        isError = true;
      }
    });
    setFormError(errors);
    if (!isError) {
      if (addressType === ADDRESS_TYPE.EDIT) {
        const changedFields = getChangedFields(editAddressFormData, addressForm);
        trackNewAddressShipToThisAddressClick({
          interactionLocation: PAGE_NAMES.EDIT_ADDRESS_PAGE,
          isInputChanged: isInputChanged.current
        });
      } else {
        trackNewAddressShipToThisAddressClick({
          interactionLocation: PAGE_NAMES.ADD_NEW_ADDRESS,
          isInputChanged: isInputChanged.current
        });
      }
      getPinCodeDetails(false, true);
    } else {
      setLoading(false);
    }
  };

  const handleSaveChangesClick = () => {
    handleFormSubmit();
    if (deviceType === DEVICE_TYPE.MOBILE) {
      setIsBottomSheetVisible(false);
    }
    if (deviceType === DEVICE_TYPE.DESKTOP) {
      if (formError) {
        setIsModalShow(false);
        setToggle(true);
        setIsShow(true);
      }
      if (!formError) {
        setIsShow(false);
        setIsModalShow(false);
      }
    }
  };

  /** We have to validate and display the city and state according to the pincode entered by the user on cart or pdp */
  useEffect(() => {
    if (pincodeValue && addressForm.pinCode.length === 6) {
      validateZipCode();
    }
  }, [pincodeValue, addressForm.pinCode]);

  useEffect(() => {
    if(addressForm.pinCode.length < 6) {
      setIsUserEditingPincode(true);
    } else {
      setIsUserEditingPincode(false);
    }
  }, [addressForm.pinCode])

  useEffect(() => {
    if(addressForm.pinCode.length < 6) {
      setIsUserEditingPincode(true);
    } else {
      setIsUserEditingPincode(false);
    }
  }, [addressForm.pinCode])

  useEffect(() => {
    if (editId) {
      setAddressType(ADDRESS_TYPE.EDIT);
      if (deviceType === DEVICE_TYPE.DESKTOP) {
        setIsShow(true);
      }
    }
  }, [editId, deviceType]);

  useEffect(() => {
    //tracking  on new address page load for apps
    if (addressType === ADDRESS_TYPE.ADD && !isImportPage) {
      trackNewAddressPageLoad({ customerId: userCustomerId, isGuest: isGuest, isFirstLandingPageAfterCheckout, isNewAddressDesignEnabled});
      allTrackingHandlerForApps({ event: TRACKING_EVENTS.ADD_NEW_ADDRESS_PAGE_LOAD, isApp, isFirstLandingPageAfterCheckout });
      setIsFirstLandingPageAfterCheckout(false);
      setCheckoutSuccessToFalseInDataLayer();
    }
  }, [isGuest, userCustomerId, addressType]);

  /**
   * @todo We need to fix this in future.
   */
  useMemo(() => {
    const currentAddress = Object.assign({}, addressForm);

    if (addressType == ADDRESS_TYPE.EDIT && addresses.length !== 0) {
      const filteredAddress: any = addresses.find(
        (address: AddressDataType) => address.customerAddressId === editId
      );

      setAddressToEdit(filteredAddress);

      const {
        firstName,
        phone,
        street,
        city,
        region,
        countryId,
        isSetDefault,
        customerAddressId,
        postcode,
        area,
        house,
        country,
        regionCode,
        regionId,
      }: any = filteredAddress;

      currentAddress.name = firstName;
      currentAddress.phone = phone;
      currentAddress.area = street;
      currentAddress.city = city;
      currentAddress.state = region;
      currentAddress.countryToShip = countryId;
      currentAddress.isdCode = COUNTRIES_META.IN.DIAL_CODE;
      currentAddress.isDefaultOptionChecked = isSetDefault;
      currentAddress.customerAddressId = customerAddressId;
      currentAddress.pinCode = postcode;

      if (!isBeautyPlatform) {
        currentAddress.area = area;
        currentAddress.house = house;
        currentAddress.countryName = country;
        currentAddress.regionCode = regionCode;
        currentAddress.regionId = regionId;
      }
    } else {
      // toggle on for guest and registered user who doesnot have any
      currentAddress.isDefaultOptionChecked = true;
      currentAddress.name = userName;
    }

    if (userEmail) {
      currentAddress.email = userEmail;
    }

    // If the pincode is prefilled by the user in the cart or pdp, we have to prefill the pincode input field
    if (pincodeValue && addressType === ADDRESS_TYPE.ADD && !isAddressIdDelCookiePresent) {
      currentAddress.pinCode = pincodeValue.toString();
    } else if ((!pincodeValue && addressType === ADDRESS_TYPE.ADD) || (pincodeValue && addressType === ADDRESS_TYPE.ADD && isAddressIdDelCookiePresent)) {
      // Auto detect location bottom sheet is not shown when user is shwown import address bottom sheet
      if (!isInputChanged.current && !cartInfo?.pincode && !fetchedImportAddressData && !(isImportAddressEnabled && showImportAddressBottomSheet) && addressType === ADDRESS_TYPE.ADD && !isImportPage) {
        setTimeout(() => {
          autoDetectAddressRef.current.pinCode?.querySelector("#pinCode")?.blur();
          clearFormError('pinCode');
        }, 0);
        trackAddAddressBottomSheetLoads()
        setShowNewDetectLocationBottomSheet(true);
      } else if (cartInfo?.pincode) {
        if(isNewAddressDesignEnabled) {
          if (!(isImportAddressEnabled && showImportAddressBottomSheet) && !fetchedImportAddressData) {
            setShowNewDetectLocationBottomSheet(true);
          }
        } else {
          setTimeout(() => {
            autoDetectAddressRef.current.houseNo?.querySelector("#addressLine1")?.focus();
          }, 0);
        }
      }
    }

    setAddressForm(currentAddress);

    if (isGuest && cartInfo.shippingAddress && deviceType === DEVICE_TYPE.DESKTOP) {
      setAddressForm({
        name: cartInfo.shippingAddress.firstName,
        phone: cartInfo.shippingAddress.contactNumber,
        house: "",
        area: "",
        pinCode: cartInfo.shippingAddress.postcode,
        email: cartInfo.shippingAddress.email,
        city: cartInfo.shippingAddress.city,
        state: cartInfo.shippingAddress.state,
        countryToShip: cartInfo.shippingAddress.country || COUNTRIES_META.IN.CODE,
        isdCode: cartInfo.shippingAddress.isdCode || COUNTRIES_META.IN.DIAL_CODE,
        isSetDefault: false,
        addressId: cartInfo.shippingAddress.addressId,
        isDefaultOptionChecked: false,
        customerAddressId: "",
        regionCode: "",
        regionId: "",
        countryName: "",
      });
    }

    if (addressType === ADDRESS_TYPE.ADD) {
      setFormError(initialErrorState);
      setAddressLoading(false);
    }
  }, [addressType, editAddressFormData, isGuest, userEmail, userName, isShow, addresses.length, fetchedImportAddressData]); // only [addressType, editAddressFormData, isGuest, userEmail, userName, addresses.length, fetchedImportAddressData] is allowed

  useEffect(() => {
    /**
     * This use effect gets the import address and show user a bottom sheet with import button.
     * User on nykaa fashion can import addresses form beauty.
     * Eligiblity: expriment enabled for new or guest user on add address flwoe
     */
    if (hasImportError) {
      setShowImportFailureToast(true);
      setTimeout(() => {
        setShowImportFailureToast(false);
      }, 3000)
    } else {
      if (isImportAddressEnabled && !addresses.length  && addressType == ADDRESS_TYPE.ADD) {
        setIsLoading(true);
        importAddress().then((response: any) => {
          if (response?.success && response?.addresses.length > 0) {
            setIsLoading(false);
            if(!isImportPage) {
              trackAddAddressBottomSheetLoads(true);
              setShowNewDetectLocationBottomSheet(false);
              setShowImportAddressBottomSheet(true);
            }
            setImportedAddresses(response?.addresses);
          }
        }).catch((error) => {
          logger.error('Error in importAddress API', error);
        })
        .finally(()=>{
          setIsLoading(false);
          setFetchedImportAddressData(false);
        });
      } else {
        setFetchedImportAddressData(false);
      }
    }
  }, []);

  const handleImportCheckBoxClick = (address: ImportAddressDataType, event: React.MouseEvent) => {
    event.preventDefault();
    const updatedAddresses = importedAddresses.map((addr: any) =>
      addr.customerAddressId === address.customerAddressId
        ? { ...addr, isChecked: !addr.isChecked }
        : addr
    );
    // Update button state based on new addresses
    const anyChecked = updatedAddresses.some((addr) => addr.isChecked);
    setIsImportButtonDisabled(!anyChecked);
    setImportedAddresses(updatedAddresses);
  };

  const getAddressImportStatus = (importedAddressesLenght: number, selectedAddressLenght: number, successfullyImportedAddressLength: number) => {
    let status = 'successful';
    if (successfullyImportedAddressLength) {
      if (importedAddressesLenght == successfullyImportedAddressLength) {
        return status;
      } else if (selectedAddressLenght == successfullyImportedAddressLength) {
        status = 'partial_synced'
      } else if (selectedAddressLenght > successfullyImportedAddressLength) {
        status = 'partial_successful'
      }
    } else {
      status = 'falied'
    }
    return status;
  }
  
  const handleImportAndSaveAddressClick = async () => {
    let selectedAddressIds = [];
    try {
      selectedAddressIds = importedAddresses
        .filter((address: ImportAddressDataType) => address.isChecked)
        .map((address: ImportAddressDataType) => address.customerAddressId);
  
      const importedAddressesLength = importedAddresses?.length || 0;
      const selectedAddressLength = selectedAddressIds?.length || 0;
  
      trackImportAddressClicked({
        no_of_address_present: importedAddressesLength,
        no_of_address_selected: selectedAddressLength,
        interaction_location: PAGE_NAMES.CHECKOUT_FLOW_ADDRESS,
      });
  
      const response = await importAndSaveAddress(selectedAddressIds);
  
      if (response?.success) {
        const successfullyImportedAddressLength = response?.addressId?.length || 0;
        const pageStatus = getAddressImportStatus(
          importedAddressesLength,
          selectedAddressLength,
          successfullyImportedAddressLength
        );
  
        trackAddressImported({
          no_of_address_present: importedAddressesLength,
          no_of_address_selected: selectedAddressLength,
          no_of_address_synced: successfullyImportedAddressLength,
          page_status: pageStatus,
          interaction_location: PAGE_NAMES.CHECKOUT_FLOW_ADDRESS,
        });
  
        trackAddressImportedSuccess();
        setImportSuccessMessage(response.title);
        setShowAddressImportedSuccessBottomSheet(true);
  
        setTimeout(() => {
          /**
           * window.history.replaceState updates the path on browser,
           * Reload is added to get the updated data on saved address page
           */
          window.history.replaceState(
            null,
            document.title,
            `${CLIENT_URLS.SAVED_ADDRESS}?src=${PAGE_NAMES.IMPORT_PAGE}`
          );
          window.location.reload();
        }, 3000);
      } else {
        trackAddressImported({
          no_of_address_present: importedAddressesLength,
          no_of_address_selected: selectedAddressLength,
          no_of_address_synced: 0,
          page_status: "failed",
          interaction_location: PAGE_NAMES.CHECKOUT_FLOW_ADDRESS,
        });
  
        history.replace(`${CLIENT_URLS.NEW_ADDRESS}?error=importError`);
      }
    } catch (error) {
      logger.error("Error in handleImportAndSaveAddressClick:", error);
  
      trackAddressImported({
        no_of_address_present: importedAddresses?.length,
        no_of_address_selected: selectedAddressIds?.length,
        no_of_address_synced: 0,
        page_status: "failed",
        interaction_location: PAGE_NAMES.CHECKOUT_FLOW_ADDRESS,
      });
  
      history.replace(`${CLIENT_URLS.NEW_ADDRESS}?error=importError`);
    }
  };

  const handleCloseImportedAddressBottomSheet = () => {
    setShowAddressImportedSuccessBottomSheet(false);
  }
  
  const genericMessageBarData = getGenericMessage(deviceType, GENERIC_MESSAGE_PAGE.ADDRESS_PAGE) || {};
  const genericMessageType = get(genericMessageBarData, "type");
  const genericMessage = get(genericMessageBarData, "message");

  let headerTitle = getStringFromId(
    VERNACULAR_STRING_IDS.ADD_NEW_ADDRESS,
    VERNACULAR_DEFAULT_MESSAGES.ADD_NEW_ADDRESS
  );
  let shipToThisAddressSubmitButtonTitle = getStringFromId(
    VERNACULAR_STRING_IDS.SHIP_TO_THIS_ADDRESS,
    VERNACULAR_DEFAULT_MESSAGES.SHIP_TO_THIS_ADDRESS
  );
  let saveAddressAndPayButtonTitle = getStringFromId(
    VERNACULAR_STRING_IDS.SAVE_ADDRESS_AND_PAY,
    VERNACULAR_DEFAULT_MESSAGES.SAVE_ADDRESS_AND_PAY
  );
  let editAddressHeaderTitle = getStringFromId(
    VERNACULAR_STRING_IDS.EDIT_ADDRESS,
    VERNACULAR_DEFAULT_MESSAGES.EDIT_ADDRESS
  );
  let importAddressHeaderTitle = getStringFromId(
    VERNACULAR_STRING_IDS.IMPORT_ADDRESS,
    VERNACULAR_DEFAULT_MESSAGES.IMPORT_ADDRESS
  );
  let optionalEmailLabel = getStringFromId(
    VERNACULAR_STRING_IDS.OPTIONAL_EMAIL,
    VERNACULAR_DEFAULT_MESSAGES.OPTIONAL_EMAIL
  );
  let emailLabel = getStringFromId(VERNACULAR_STRING_IDS.EMAIL, VERNACULAR_DEFAULT_MESSAGES.EMAIL);
  const pincodeBottomSheetTitle = getStringFromId(
    VERNACULAR_STRING_IDS.PINCODE_BOTTOM_SHEET_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.PINCODE_BOTTOM_SHEET_TITLE
  );
  const pincodeBottomSheetSubTitle = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_CURRENTLY_DONOT_DELIVER_TO,
    `Currently we do not deliver to ${addressForm.pinCode}`
  );
  const pincodeBottomSheetActionButtonText = getStringFromId(
    VERNACULAR_STRING_IDS.GOT_IT,
    VERNACULAR_DEFAULT_MESSAGES.GOT_IT
  );
  const vernacularMessages = {
    title: getStringFromId(VERNACULAR_STRING_IDS.ADDRESS, VERNACULAR_DEFAULT_MESSAGES.ADDRESS),
    autoDetectLocation: getStringFromId(
      VERNACULAR_STRING_IDS.AUTO_DETECT,
      VERNACULAR_DEFAULT_MESSAGES.AUTO_DETECT
    ),
    pinCodeLabel: getStringFromId(
      VERNACULAR_STRING_IDS.PINCODE,
      VERNACULAR_DEFAULT_MESSAGES.PINCODE
    ),
    houseLabel: getStringFromId(
      VERNACULAR_STRING_IDS.HOUSE_LABEL,
      VERNACULAR_DEFAULT_MESSAGES.HOUSE_LABEL
    ),
    areaLabel: getStringFromId(
      VERNACULAR_STRING_IDS.AREA_LABEL,
      VERNACULAR_DEFAULT_MESSAGES.AREA_LABEL
    ),
    cityLabel: getStringFromId(VERNACULAR_STRING_IDS.CITY, VERNACULAR_DEFAULT_MESSAGES.CITY),
    stateLabel: getStringFromId(VERNACULAR_STRING_IDS.STATE, VERNACULAR_DEFAULT_MESSAGES.STATE),
    nameLabel: getStringFromId(VERNACULAR_STRING_IDS.NAME, VERNACULAR_DEFAULT_MESSAGES.NAME),
    contactTitle: getStringFromId(
      VERNACULAR_STRING_IDS.CONTACT,
      VERNACULAR_DEFAULT_MESSAGES.CONTACT
    ),
    phoneLabel: getStringFromId(VERNACULAR_STRING_IDS.PHONE, VERNACULAR_DEFAULT_MESSAGES.PHONE),
    emailLabel: isGuest ? emailLabel : optionalEmailLabel,
    privacyNote: getStringFromId(
      VERNACULAR_STRING_IDS.NEW_ADDRESS_PRIVACY_NOTE,
      VERNACULAR_DEFAULT_MESSAGES.NEW_ADDRESS_PRIVACY_NOTE
    ),
    privacyNoteNew: getStringFromId(
      VERNACULAR_STRING_IDS.NEW_ADDRESS_PRIVACY_NOTE_NEW,
      VERNACULAR_DEFAULT_MESSAGES.NEW_ADDRESS_PRIVACY_NOTE_NEW
    ),
    bottomSheetTitle: getStringFromId(
      VERNACULAR_STRING_IDS.CHANGES_NOT_SAVED,
      VERNACULAR_DEFAULT_MESSAGES.CHANGES_NOT_SAVED
    ),
    bottomSheetContent: getStringFromId(
      VERNACULAR_STRING_IDS.CHANGES_NOT_SAVED_CONTENT,
      VERNACULAR_DEFAULT_MESSAGES.CHANGES_NOT_SAVED_CONTENT
    ),
    cancelButtonTitle: getStringFromId(
      VERNACULAR_STRING_IDS.DONT_SAVE,
      VERNACULAR_DEFAULT_MESSAGES.DONT_SAVE
    ),
    successButtonTitle: getStringFromId(
      VERNACULAR_STRING_IDS.SAVE_CHANGES,
      VERNACULAR_DEFAULT_MESSAGES.SAVE_CHANGES
    ),
    autoDetectBottomSheetTitle: getStringFromId(
      VERNACULAR_STRING_IDS.AUTO_DETECT_BOTTOMSHEET_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.AUTO_DETECT_BOTTOMSHEET_TITLE
    ),
    savedAsPrimaryAddress: getStringFromId(
      VERNACULAR_STRING_IDS.SAVED_AS_PRIMARY_ADDRESS,
      VERNACULAR_DEFAULT_MESSAGES.SAVED_AS_PRIMARY_ADDRESS
    ),
    useAsPrimaryAddress: getStringFromId(
      VERNACULAR_STRING_IDS.USE_AS_PRIMARY_ADDRESS,
      VERNACULAR_DEFAULT_MESSAGES.USE_AS_PRIMARY_ADDRESS
    ),
    newAutoDetectBottomSheetTitle: getStringFromId(
      VERNACULAR_STRING_IDS.NEW_AUTO_DETECT_BOTTOM_SHEET_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.NEW_AUTO_DETECT_BOTTOM_SHEET_TITLE
    ),
    newAutoDetectBottomSheetSubTitle: getStringFromId(
      VERNACULAR_STRING_IDS.NEW_AUTO_DETECT_BOTTOM_SHEET_SUB_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.NEW_AUTO_DETECT_BOTTOM_SHEET_SUB_TITLE
    ),
    addManuallyBtn: getStringFromId(
      VERNACULAR_STRING_IDS.ADD_MANUALLY_BTN,
      VERNACULAR_DEFAULT_MESSAGES.ADD_MANUALLY_BTN
    ),
    detectLocationBtn: getStringFromId(
      VERNACULAR_STRING_IDS.DETECT_LOCATION_BTN,
      VERNACULAR_DEFAULT_MESSAGES.DETECT_LOCATION_BTN
    ),
    locationPermissionText: getStringFromId(
      VERNACULAR_STRING_IDS.LOCATION_PERMISSION_TEXT,
      VERNACULAR_DEFAULT_MESSAGES.LOCATION_PERMISSION_TEXT
    ),
    importAddressBottomSheetTitle: getStringFromId(
      VERNACULAR_STRING_IDS.IMPORT_ADDRESS_BOTTOM_SHEET_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.IMPORT_ADDRESS_BOTTOM_SHEET_TITLE
    ),
    importAddressBottomSheetSubTitle: getStringFromId(
      VERNACULAR_STRING_IDS.IMPORT_ADDRESS_BOTTOM_SHEET_SUB_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.IMPORT_ADDRESS_BOTTOM_SHEET_SUB_TITLE
    ),
    importButtonText: getStringFromId(
      VERNACULAR_STRING_IDS.IMPORT_BUTTON_TEXT,
      VERNACULAR_DEFAULT_MESSAGES.IMPORT_BUTTON_TEXT
    ),
    importErrorText: getStringFromId(
      VERNACULAR_STRING_IDS.IMPORT_ERROR_TEXT,
      VERNACULAR_DEFAULT_MESSAGES.IMPORT_ERROR_TEXT
    ),
  };
  let submitButtonTitle = isNewAddressDesignEnabled ? saveAddressAndPayButtonTitle : shipToThisAddressSubmitButtonTitle;

  if (isPaymentFormAddressPageExpEnable) {
    submitButtonTitle = `Proceed to Pay ₹${orderAmount}`;
  }

  if (addressType == ADDRESS_TYPE.EDIT) {
    headerTitle = editAddressHeaderTitle;
  }

  const ProviderValue = {
    headerTitle,
    submitButtonTitle,
    genericMessage,
    genericMessageType,
    addressForm,
    isEditing: addressType == ADDRESS_TYPE.EDIT,
    formError,
    isLoading,
    handleBackButton,
    getCurrentGeoLocation,
    handleDefaultAddressToggle,
    handleInputChange,
    handlePinCodeBlur: validateZipCode,
    handleInputBlur: validateFormInput,
    onSubmit: handleFormSubmit,
    handleDontSaveClick,
    handleCloseBottomModal,
    handleSaveChangesClick,
    isBottomSheetVisible,
    isAutoDetectLocationEnabled: AutoDetectLocation?.switchEnabled,
    isAutoDetectLocationBottomSheetEnabled: AutoDetectLocationBottomSheet?.switchEnabled,
    isGuestUser: isGuest,
    vernacularMessages,
    isPincodeBottomSheetVisible,
    pincodeBottomSheetTitle,
    pincodeBottomSheetSubTitle,
    pincodeBottomSheetActionButtonText,
    onPincodeBottomSheetClose,
    nameInputIconVisible,
    phoneInputIconVisible,
    emailInputIconVisible,
    nameInputIcon,
    phoneInputIcon,
    emailInputIcon,
    clearInputField,
    clearPhoneInputField,
    clearEmailInputField,
    isModalShow,
    secondaryButtonAction,
    setToggle,
    hideEmail,
    autoDetectBottomSheetSubtitle,
    showAutoDetectBottomSheet,
    handleCloseAutoDetectBottomSheet,
    handleSuccessAutoDetectBottomSheet,
    autoDetectAddressRef,
    loadingParams,
    scrollToErrorField,
    isUserEditingPincode,
    fetchingGeoLocation,
    errorFetchingGeoLocation,
    showNewDetectLocationBottomSheet,
    handleCloseNewAutoDetectBottomSheet,
    handleNewAutoDetectBottomSheetClick,
    handleAddAddressManuallyClick,
    showPermissionToast,
    setShowPermissionToast,
    isImportAddressEnabled,
    showImportAddressBottomSheet,
    handleCloseImportBottomSheet,
    handleImportAddressClick,
    importAddressHeaderTitle,
    importedAddresses,
    handleImportCheckBoxClick,
    handleImportAndSaveAddressClick,
    isImportButtonDisabled,
    showAddressImportedSuccessBottomSheet, 
    setShowAddressImportedSuccessBottomSheet,
    handleCloseImportedAddressBottomSheet,
    importSuccessMessage,
    showImportFailureToast,
    setShowImportFailureToast,
    handleAddManuallyFromNewAutoDetectBottomSheet,
    handleAddManuallyFromImportBottomSheet
  };

  return (
    <NewAddressContextProvider value={ProviderValue}>{props.children}</NewAddressContextProvider>
  );
};
